var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoupe1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1955 5108 c-304 -30 -646 -146 -905 -305 -279 -173 -550 -444 -723 -723 -342 -556 -410 -1269 -180 -1890 240 -648 799 -1157 1465 -1335 506 -136 1005 -87 1521 147 l68 31 457 -454 c488 -485 513 -506 652 -550 92 -29 208 -35 300 -15 95 20 219 81 289 143 72 63 145 176 178 277 23 70 27 98 27 206 0 110 -3 134 -26 201 -54 154 -69 172 -541 646 l-440 442 31 68 c295 645 294 1312 -3 1912 -117 235 -242 408 -427 587 -107 105 -146 139 -238 206 -433 315 -970 460 -1505 406z m495 -522 c710 -116 1257 -670 1371 -1391 17 -103 17 -387 0 -490 -87 -549 -414 -996 -908 -1244 -230 -114 -456 -165 -733 -165 -224 0 -375 25 -570 96 -341 124 -652 376 -838 680 -225 367 -301 797 -216 1218 20 100 87 297 131 385 195 390 525 688 920 831 148 53 276 81 458 98 71 7 297 -4 385 -18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupe1);
export default __webpack_public_path__ + "static/media/loupe-_1_.fa3df61ecc3964c7b09f381f8b34f522.svg";
export { ForwardRef as ReactComponent };